"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

const typography = require("!!css-loader!../../tokens/typography.css").default;
function _clear () {
    this.innerHTML = "";
}

class Banner extends HTMLElement {


    constructor(template) {
        super(template);


        this.root = this.attachShadow({ mode: "open" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(typography);
        this.root.adoptedStyleSheets = [sheet];

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.root.querySelector("div");

        // see https://github.com/WICG/webcomponents/issues/903
        // this.observer = new MutationObserver(() => {
        //     if (this.innerHTML) {
        //         this.connectedCallback();
        //     }
        // });
        // this.observer.observe(this, { subtree: true, childList: true, characterData: true });
    }



    // see https://carbondesignsystem.com/components/button/usage
    static get observedAttributes() {
        return ["text"];
    }

    get text() {
        return this.getAttribute("text");
    }
    set text(text) {
        this.setAttribute("text", text);
    }


    attributeChangedCallback(name, oldVal, newVal) {

        if (name === "text") {
            const label = this.container.querySelector("label");
            label.innerText = newVal;
        }
    }

    connectedCallback() {
        this.state = this.getAttribute("state") || "info";
        // if (this.innerHTML) {
            const icon = document.createElement("swiftref-icon");
            icon.setAttribute("kind", this.state);
            const label = document.createElement("label");
            label.innerHTML = this.innerHTML || "";
            this.container.innerHTML = "";
            this.container.appendChild(icon);
            this.container.appendChild(label);
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(_clear.bind(this), 1);

            if (this.hasAttribute("clear_icon")) {
                const clearIcon = document.createElement("span");
                clearIcon.innerText = "x";
                clearIcon.className = "clear-icon";
                clearIcon.addEventListener("click", this.removeTag.bind(this));
                this.container.appendChild(clearIcon);
            }
        // }


    }

    removeTag(event) {
        const isPrevented = !this.dispatchEvent(new CustomEvent("remove-banner", {
            bubbles: true,
            cancelable: true
            // composed: true
        }))
        if (!isPrevented) {
            try {
                this.parentElement.removeChild(this);
            } catch (e) {}

        }
    }

}

window.customElements.define("swiftref-banner", Banner);

module.exports = Banner;
